"use strict";
/**
 * Weekly Report V2 — Evaluation Types
 *
 * Shared types for timeline-based evaluation.
 * Used by both backend (schema JSONB typing, services) and frontend (display).
 *
 * Core concept: raw event tables are the source of truth. At report time,
 * EvaluationContextService computes per-product and per-treatment timelines,
 * derives phases, and produces point-in-time evaluation snapshots.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.baselineQualityEnum = exports.BaselineQuality = void 0;
// ============================================================================
// BASELINE QUALITY
// ============================================================================
/**
 * Quality of the baseline reference for an evaluation.
 * - full: Sufficient pre-change data points for a reliable baseline
 * - partial: Some pre-change data, but below ideal threshold
 * - none: No pre-change data available (baseline starts from first scan)
 */
exports.BaselineQuality = {
    FULL: 'full',
    PARTIAL: 'partial',
    NONE: 'none',
};
exports.baselineQualityEnum = Object.values(exports.BaselineQuality);
//# sourceMappingURL=evaluation.js.map